import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { class: "col-12 col-md-9" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3 text-success" }, [
    /*#__PURE__*/_createTextVNode("角田 峻太郎 "),
    /*#__PURE__*/_createElementVNode("small", null, "(すみた しゅんたろう)")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 d-block" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_9 = { class: "col-11 mb-3" }
const _hoisted_10 = { class: "mb-0 u-pre-line" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "col-6 col-md-3" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.myself.affiliation), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", null, _toDisplayString(_ctx.myself.text), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("img", {
            src: `/${_ctx.myself.imageFile}`,
            alt: "profile",
            class: "img-thumbnail"
          }, null, 8, _hoisted_13)
        ])
      ])
    ])
  ]))
}